var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDriveFileMoveOutline(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2259_4845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 3.49967H6.99999L5.83332 2.33301H2.33332C1.69166 2.33301 1.17249 2.85801 1.17249 3.49967L1.16666 10.4997C1.16666 11.1413 1.69166 11.6663 2.33332 11.6663H11.6667C12.3083 11.6663 12.8333 11.1413 12.8333 10.4997V4.66634C12.8333 4.02467 12.3083 3.49967 11.6667 3.49967ZM11.6667 10.4997H2.33332V4.66634H11.6667V10.4997ZM6.99416 5.24967L6.17166 6.07217L7.09332 6.99967H4.66666V8.16634H7.09332L6.16582 9.09384L6.99416 9.91634L9.33332 7.58884L6.99416 5.24967Z",
    fill: "#384F6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2259_4845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveFileMoveOutline);
export default __webpack_public_path__ + "static/media/drive-file-move-outline.b53ac53f2b2a3a93f5d55ac964b33612.svg";
export { ForwardRef as ReactComponent };